import React, { useState } from "react";
import axios from "axios";
import Results from "./Results";
import "./Dictionary.css";
import Photos from "./Photos";



export default function Dictionary(props){
    let [keyword, setKeyword] = useState(props.defaultKeyword);
    let [results, setResults] = useState(null);
    let [loaded, setLoaded] = useState(false);
    let [photos, setPhotos] = useState(null);


    function handleDictionaryResponse(response){
        setResults(response.data[0]);
    }


    function handlePexelsResponse(response){
        setPhotos(response.data.photos);

    }
    function search(){
        let apiUrl = `https://api.dictionaryapi.dev/api/v2/entries/en_US/${keyword}`;
        axios.get(apiUrl).then(handleDictionaryResponse);
    }



    function handleSubmit(event){
        event.preventDefault();
        search();



        let pexelsApiKey = "563492ad6f91700001000001b54efec8297c4e6ea5a3b9a626aa472b";
        let pexelsApiUrl = `https://api.pexels.com/v1/search?query=${keyword}&per_page=6`;
        let headers = {"Authorization" : `Bearer ${pexelsApiKey}`};
        axios.get(pexelsApiUrl, { headers: headers }).then(handlePexelsResponse);
    }

    

    function handleKeywordChange(event){
        setKeyword(event.target.value)
    }

    function load() {
    setLoaded(true);
    search()
    }

    if(loaded){
        return (
            <div className="Dictionary">
                <section>
                <form onSubmit={handleSubmit}>
                    <input type="search" onChange={handleKeywordChange} defaultValue={props.defaultKeyword}/>
                </form>
                <div className="hint">
                    suggested word: sunset, wine, yoga....
                </div>
                </section>
                <Results results={results}/>
                <Photos photos={photos} />
            </div>
        );  
    } else {
        load()
            return "Loading.."
}
}